import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import { Menu, MenuItem } from "@material-ui/core";
import { Checkbox, FormControlLabel, Grid } from "@material-ui/core";
import Container from "@material-ui/core/Container"

import Paper from "@material-ui/core/Paper"

import "react-modern-calendar-datepicker/lib/DatePicker.css"
import TextField from '@material-ui/core/TextField';
import Typography from "@material-ui/core/Typography";
import Calendar from "react-modern-calendar-datepicker";


const InsuranceDatePicker = ({
                                 selectedDateBodycar,
                                 selectedDateLiability,
                                 selectedDateThirdparty,
                                 setSelectedDateBodycar,
                                 setSelectedDateLiability,
                                 setSelectedDateThirdparty,
                                 onSubmit,
                                 requestId,
                                 doci
                             }) => {

    console.log("aaaaaaaaaaaaaaaa",selectedDateThirdparty)
    return (
            <Paper elevation={4} style={{ padding: 24, borderRadius: 16, margin: 24 , textAlign:"right" }}>
                <Grid container spacing={2}>
                    <Grid item xs={4}>
                        <Typography variant="body1" style={{ marginBottom: 8 }}>تاریخ بیمه بدنه</Typography>
                        <Calendar
                            renderInput={({ ref }) => (
                                <TextField
                                    fullWidth
                                    inputRef={ref}
                                    variant="outlined"
                                    value={
                                        selectedDateBodycar
                                            ? `${selectedDateBodycar.year}/${String(selectedDateBodycar.month).padStart(2, '0')}/${String(selectedDateBodycar.day).padStart(2, '0')}`
                                            : ''
                                    }
                                    placeholder="تاریخ بیمه بدنه"
                                />
                            )}
                            value={selectedDateBodycar}
                            onChange={(val) => setSelectedDateBodycar(val)}
                            locale="fa"
                            shouldHighlightWeekends
                        />
                    </Grid>

                    <Grid item xs={4}>
                        <Typography variant="body1" style={{ marginBottom: 8 }}>تاریخ بیمه مسئولیت</Typography>
                        <Calendar
                            renderInput={({ ref }) => (
                                <TextField
                                    fullWidth
                                    inputRef={ref}
                                    variant="outlined"
                                    value={
                                        selectedDateLiability
                                            ? `${selectedDateLiability.year}/${String(selectedDateLiability.month).padStart(2, '0')}/${String(selectedDateLiability.day).padStart(2, '0')}`
                                            : ''
                                    }
                                    placeholder="تاریخ بیمه مسئولیت"
                                />
                            )}
                            value={selectedDateLiability}
                            onChange={(val) => setSelectedDateLiability(val)}
                            locale="fa"
                            shouldHighlightWeekends
                        />
                    </Grid>

                        {doci === "yes" && (
                            <Grid item xs={4}>
                                <Typography variant="body1" style={{ marginBottom: 8 }}>تاریخ بیمه ثالث</Typography>
                                <Calendar
                                    renderInput={({ ref }) => (
                                        <TextField
                                            fullWidth
                                            inputRef={ref}
                                            variant="outlined"
                                            value={
                                                selectedDateThirdparty
                                                    ? `${selectedDateThirdparty.year}/${String(selectedDateThirdparty.month).padStart(2, '0')}/${String(selectedDateThirdparty.day).padStart(2, '0')}`
                                                    : ''
                                            }
                                            placeholder="تاریخ بیمه ثالث"
                                        />
                                    )}
                                    value={selectedDateThirdparty}
                                    onChange={(val) => setSelectedDateThirdparty(val)}
                                    locale="fa"
                                    shouldHighlightWeekends
                                />
                            </Grid>
                        )}

                    <Grid item xs={2} style={{ display: 'flex', alignItems: 'center' }}>
                        <Button
                            variant="contained"
                            color="primary"
                            onClick={() => onSubmit(requestId)}
                        >
                            ثبت
                        </Button>
                    </Grid>
                </Grid>
            </Paper>
    );
};

export default InsuranceDatePicker;
